import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import { useAuth } from 'src/auth/hooks/useAuth';
import { menuWidth, menuWidthSmall } from '../../AppLayout.styles';

import { useState } from 'react';
import { BrandingLogo } from '@/branding/BrandingLogo';
import { NavigationMenu } from './NavigationMenu';

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    transition: 'width 0.2s ease-in-out',
    '& .MuiListItemText-root': {
      transition: 'opacity 0.2s ease-in-out',
      opacity: '0%',
    },
    width: theme.spacing(menuWidthSmall),
    '& .MuiDrawer-paper': {
      zIndex: '1200',
      transition: 'width 0.2s ease-in-out',
      width: theme.spacing(menuWidthSmall),
    },
    ...(open && {
      '@media (hover: hover)': {
        '& .MuiListItemText-root': {
          opacity: '100%',
        },
        width: theme.spacing(menuWidth),
        '& .MuiDrawer-paper': {
          width: theme.spacing(menuWidth),
        },
      },
    }),
    a: {
      color: 'inherit',
    },
  }),
);

export const NavigationSidebar = () => {
  const { user } = useAuth();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <Drawer
      variant="permanent"
      elevation={24}
      PaperProps={{ elevation: 8, sx: { borderRight: 0, overflowX: 'hidden' } }}
      open={isDrawerOpen}
      onMouseOver={handleDrawerOpen}
      onMouseOut={handleDrawerClose}
      role="navigation"
      aria-label="Main"
    >
      <Box
        sx={{
          mb: 32,
          ml: 8,
          mt: 12,
        }}
      >
        <BrandingLogo accountRef={+user.referenceId} />
      </Box>
      <NavigationMenu />
    </Drawer>
  );
};
